/**
 * Application-specific types and constants.
 * 
 * For API types, import directly from "./generated/types.gen"
 */

import type { UserResponse } from "./generated/types.gen";

// Application-specific types
export type User = UserResponse;

export interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

export interface DecodedToken {
  exp: number;
  sub: string;
  email: string;
  role: "admin" | "client";
}

export const TOKEN_KEYS = {
  ACCESS: "auth_access_token",
  REFRESH: "auth_refresh_token",
} as const;
